<script lang="ts">
  export let videoId: string;
</script>
{#if videoId}
  <div id="video-container" data-testid="video" class="mt-4 lg:mt-10 h-[15rem] lg:h-[25rem]">
    <iframe
      title="youtube-embedded-video"
      width="100%"
      height="100%"
      src="https://www.youtube-nocookie.com/embed/{videoId}?autoplay=1&controls=1&modestbranding=1&playsinline=1&rel=0&mute=1"
      frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>
    </iframe>
  </div>
{/if}
